import { ButtonTriggerEvent } from '../../../../common/components';

export class EditTourTitleModalActions {
    confirm: (event: ButtonTriggerEvent, title, description) => void;
    cancel?: () => void;
}

export class EditTourTitleModalData {
    isAsync: true;
    id: string;
    title: string;
    description: string;
    hubName: string;
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/tours/edit.tour.title.modal/edit.tour.title.modal.provider.ts